import Vue from "vue";
import VuetifyNumber from "vuetify-number";
Vue.use(VuetifyNumber);
export default VuetifyNumber;